import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { N1StaticDatumsEditCard } from "./edit_card";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const N1StaticDatumsEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <N1StaticDatumsEditCard id={Number(id)} client={Clients.N1} />
        <AuditCard
          id={Number(id)}
          client={Clients.N1}
          audit_table_name={Tables.N1_STATIC_DATA}
        />
      </div>
    </div>
  );
};
